var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('v-divider')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4 ml-3"},[_c('h1',[_vm._v("Błąd 404")]),_c('p',[_vm._v("Nie odnaleziono strony")])])}]

export { render, staticRenderFns }